<template lang="pug">
.generic-wrapper
  .container
    BackButton(name="CMSOverview")
    h1.title Alle Medien
    .sub-headline Hier können Sie alle Medien verwalten.

    .button-wrapper.margin-top
      UploadMedia(
        @update="getMedias(); activeMediaId = null",
        :id="activeMediaId",
        @close="activeMediaId = null",
        allowPdf
      )

    .card.margin-top
      .main
        b-table(
          :data="medias",
          default-sort-direction="desc",
          default-sort="createdAt",
          hoverable,
          @click="(row) => openMedia(row.id)"
        )
          b-table-column(label="Vorschau", sortable, v-slot="props")
            img(
              v-if="props.row.isPdf",
              src="@/assets/pdf_icon.svg",
              width="100px"
            )
            img(
              v-else-if="props.row.thumbnailUrl",
              :src="props.row.thumbnailUrl"
            )
            span(v-else) Keine Vorschau
          b-table-column(
            field="name",
            label="Name",
            sortable,
            searchable,
            v-slot="props"
          )
            | {{ props.row.name }}
            template(v-if="props.row.isPdf")
              br
              div(style="opacity: 1;")
                a(
                  :id="`${props.row.id}-vorschau`",
                  :href="props.row.url",
                  target="_blank",
                  style="display: flex; align-items: center; gap: 0.5rem"
                )
                  img(
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHTSURBVHgBtVNLS+NgFD1pa+pAkkmnMwzopruZTmcxjG83Vt3rT1B/gSC4VhduRREFd4KPtQpuRKwr8Ul9gK+VCxtcRNQ8qo0m+n2RFjXRNFAPfLlfLvcezrk3AUoMxi2paVonCR3wgGVZI4IgzDkI16oahn9eyu30HhBFlDfWi7ndfbG8vhbG4TECX3mEKitxt75ZaPy+tEjDNTnNHMft5vMh+ghapkhCjN7Z37+QbahDtOo/2EQcuqojfHMNfWkZpiS9FUn7UsRRgTTgZiUcj+N2YxPmeQa6rtk582/CUaeqKj2ioiipdDr9z5XQUhRkRseQJYquot/A7R9AkS6QGxpxEPI8bx8yRzESiXQXLF/+EOeMstCZXSXLiCT+ND329iTp/Ixo9Lm7twfFwHXLxEY/wzB9b/N0hgGOByPwjh5ZlidjsViX6wzfg5mRcDu/8GGNL8KH4xPPGl+EFtlqWU116Qjvt3ZgZaTSEBpb2wi3JG2V+viE/Z6dnsGjor6qCxVDlltJITs1C2FwAMGKCnvb90en5JtVYWkqgi+27klIlRjEap6Mgkb73pp01Htapmqo1TyZFzwVfmlvgx/42nIxcFVIfrszElbhAyzL7uEz8ATXxapsTHynvgAAAABJRU5ErkJggg=="
                  )
                  | 
                  | Jetzt PDF öffnen: {{props.row.name}}
              b-button(type="is-flat", @click.stop="copyLink(props.row)") Link für E-Mail Vorlage kopieren
          b-table-column(
            field="description",
            label="SEO Beschreibung",
            sortable,
            v-slot="props"
          )
            | {{ props.row.description }}
          b-table-column(
            field="createdAt",
            label="erstellt am",
            sortable,
            v-slot="props"
          )
            | {{ formatDate(props.row.createdAt) }}
          b-table-column(v-slot="props")
            div
              b-tooltip(
                label="Dauerhaft löschen",
                type="is-danger",
                position="is-bottom",
                :delay="1250"
              )
                b-button(
                  icon-right="close",
                  type="is-danger",
                  @click.stop="deleteMedia(props.row)"
                )
</template>

<script>
import { DateTime } from "luxon";
import UploadMedia from "@/components/molecules/UploadMedia.vue";

export default {
  components: {
    UploadMedia,
  },
  data() {
    return {
      isModalActive: true,
      activeMediaId: null,
    };
  },
  computed: {
    medias() {
      return this.$store.state.medias.all;
    },
  },
  methods: {
    copyLink(media) {
      const doc = document;
      const text = doc.getElementById(`${media.id}-vorschau`);
      let range;
      let selection;

      if (doc.body.createTextRange) {
        range = doc.body.createTextRange();
        range.moveToElement(text);
        range.select();
      } else if (window.getSelection) {
        selection = window.getSelection();

        range = doc.createRange();
        range.selectNodeContents(text);

        selection.removeAllRanges();
        selection.addRange(range);
      }

      document.execCommand("copy");
      window.getSelection().removeAllRanges();
      document.getElementById(`${media.id}-vorschau`).value = "Erfolgreich kopiert!";
    },
    deleteMedia(row) {
      this.$buefy.dialog.confirm({
        title: "Medium löschen",
        message: `Sind Sie sicher, dass Sie dieses Medium <b>${row.name}</b> löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.`,
        confirmText: "Medium löschen",
        cancelText: "Abbrechen",
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          try {
            await this.$store.dispatch("medias/delete", { id: row.id });
            this.$store.dispatch("medias/findAll");
          } catch (e) {
            this.$store.dispatch(
              "common/showError",
              "Medium konnte nicht gelöscht werden."
            );
          }
        },
      });
    },
    formatDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.setLocale("de").toFormat("dd. LLL. yyyy hh:mm");
    },
    getMedias() {
      this.$store.dispatch("medias/findAll");
    },
    openMedia(id) {
      this.activeMediaId = id;
    },
  },
  mounted() {
    this.getMedias();
  },
};
</script>

<style lang="scss" scoped>
.icon-name {
  margin-left: $sm-space;
}
</style>